export default __webpack_public_path__ + "static/media/R_Rei.68c7c38f.mp3";